<div [hidden]="!loading">
  <ab-spinner></ab-spinner>
</div>
<span *ngIf="!loading"
  ><a
    class="dash-list-item"
    *ngFor="let hotspot of hotspots; trackBy: trackBy"
    uiSref="project-errors"
    [uiParams]="errorSearchParams(hotspot)"
    [uiOptions]="{ reload: true }"
    [ngbTooltip]="selectedAttributeType?.tooltip(hotspot)"
    tooltipClass="tooltip--break-word"
    ><span class="dash-list-item__number">{{ hotspot.count }}</span
    ><span class="dash-list-item__circle" [ngClass]="hotspot.dotColor"></span
    ><span class="dash-list-item__text">{{ hotspot.displayValue }}</span></a
  >
  <div class="span" *ngIf="showEmptyState">
    <div class="blankslate">
      <p class="blankslate__text">
        No data for the chosen time period<br /><ab-external-link
          *ngIf="selectedAttributeType.attrKey === 'context.user'"
          href="https://docs.airbrake.io/docs/features/hotspots-users/"
          >Learn more about user hotspots</ab-external-link
        >
      </p>
      <img
        class="blankslate__image"
        src="{{ appEnv.cdnUrl }}/{{ appEnv.assetsPath }}/images/blankslate.svg"
      />
    </div></div
></span>
